<template>
  <div class="card p-shadow-app">
    <h2 class="mb-2">Ordenar PATs</h2>

    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />

    <draggable v-model="pats" @end="onReorder" tag="ul" class="p-list">
      <li v-for="(pat, index) in pats" :key="pat.id" class="p-item">
        <span class="p-order">#{{ index + 1 }}</span>
        <span class="p-name">{{ pat.field }}</span>
        <divider layout="vertical" />
        <span class="p-d-flex p-flex-column p-ai-center">
          <label :for="pat.id">Listagem Pats</label>
          <Checkbox
            v-model="pat.show_in_pat_list"
            :inputId="pat.id"
            :name="pat.id"
            :id="pat.id"
            :binary="true"
            :trueValue="1"
            :falseValue="0"
            class="p-mt-2"
            @change="toogleShowList(pat.id)"
          />
        </span>
        <divider layout="vertical" />
        <span class="p-d-flex p-flex-column p-ai-center">
          <label :for="pat.id">Mapa</label>
          <Checkbox
            v-model="pat.show_in_map"
            :inputId="pat.id"
            :name="pat.id"
            :id="pat.id"
            :binary="true"
            :trueValue="1"
            :falseValue="0"
            class="p-mt-2"
            @change="toogleShowMaps(pat.id)"
          />
        </span>
        <divider layout="vertical" />
        <span
          class="p-color"
          :style="{ backgroundColor: pat.color }"
          @click="editColor(pat)"
        >
          {{ pat.color }}
        </span>
        <divider layout="vertical" />
        <div class="arrows">
          <Button
            icon="pi pi-arrow-up"
            @click="moveUp(index)"
            class="p-button-text p-button-sm"
            :disabled="index === 0"
          />
          <Button
            icon="pi pi-arrow-down"
            @click="moveDown(index)"
            class="p-button-text p-button-sm"
            :disabled="index === pats.length - 1"
          />
        </div>
      </li>
    </draggable>

    <Dialog
      header="Alterar Cor"
      :visible="colorDialogVisible"
      @hide="colorDialogVisible = false"
      :modal="true"
      :closable="false"
      class="color-dialog"
    >
      <div class="color-container">
        <ColorPicker
          v-model="selectedColor"
          format="hex"
          :inline="true"
          class="color-picker"
        />

        <div class="preview-box">
          <h3>Pré-visualizar cor:</h3>
          <div
            class="color-preview"
            :style="{
              backgroundColor: selectedColor.startsWith('#')
                ? selectedColor
                : '#' + selectedColor,
            }"
          ></div>
          <div class="color-code">
            {{
              selectedColor.startsWith("#")
                ? selectedColor
                : "#" + selectedColor
            }}
          </div>
        </div>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <Button
            label="Cancelar"
            class="p-button-text"
            @click="colorDialogVisible = false"
          />
          <Button label="Salvar" @click="saveColor" />
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import PatService from "../services/pat.service";
import ColorPicker from "primevue/colorpicker";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import draggable from "vuedraggable";

export default {
  components: {
    ColorPicker,
    Dialog,
    Button,
    draggable,
  },
  data() {
    return {
      pats: [],
      colorDialogVisible: false,
      selectedPat: null,
      selectedColor: "#000000",
    };
  },
  created() {
    this.fetchPats();
  },
  methods: {
    async fetchPats() {
      return (this.pats = await PatService.getAllStatus());
    },
    updateOrder() {
      this.pats.forEach((pat, index) => {
        pat.number_order = index + 1;
      });
    },
    async onReorder() {
      this.updateOrder();
      try {
        const promises = this.pats.map((pat, index) => {
          return PatService.updatePat(pat.id, {
            number_order: index + 1,
            color: pat.color,
          });
        });
        await Promise.all(promises);
      } catch (err) {
        console.error("Erro ao atualizar ordem:", err);
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Falha ao atualizar ordem dos PATs.",
          life: 3000,
        });
      }
    },
    editColor(pat) {
      this.selectedPat = pat;
      this.selectedColor = pat.color || "#000000";
      this.colorDialogVisible = true;
    },
    async saveColor() {
      if (this.selectedPat) {
        const updatedColor = this.selectedColor.startsWith("#")
          ? this.selectedColor
          : "#" + this.selectedColor;

        this.selectedPat.color = updatedColor;

        try {
          await PatService.updatePat(this.selectedPat.id, {
            number_order: this.selectedPat.number_order,
            color: updatedColor,
          });
        } catch (err) {
          console.error("Erro ao atualizar cor:", err);
          this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: "Falha ao atualizar cor do PAT.",
            life: 3000,
          });
        }
      }
      this.colorDialogVisible = false;
    },
    async moveUp(index) {
      if (index > 0) {
        const temp = this.pats[index - 1];
        this.pats.splice(index - 1, 1, this.pats[index]);
        this.pats.splice(index, 1, temp);
        await this.onReorder();
      }
    },
    async moveDown(index) {
      if (index < this.pats.length - 1) {
        const temp = this.pats[index + 1];
        this.pats.splice(index + 1, 1, this.pats[index]);
        this.pats.splice(index, 1, temp);
        await this.onReorder();
      }
    },
    async toogleShowList(statusId) {
      try {
        await PatService.toogleShowList(statusId);
      } catch (err) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Falha ao atualizar cor do PAT.",
          life: 3000,
        });
      }
    },
    async toogleShowMaps(statusId) {
      try {
        await PatService.toogleShowMaps(statusId);
      } catch (err) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Falha ao atualizar cor do PAT.",
          life: 3000,
        });
      }
    },
  },
};
</script>

<style scoped>
.p-list {
  list-style: none;
  padding: 0;
}
.p-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background: #f7f7f7;
  margin-bottom: 5px;
  border-radius: 5px;
  cursor: grab;
  gap: 10px;
}
.p-order {
  font-weight: bold;
  width: 30px;
}
.p-name {
  flex: 1;
  font-weight: bold;
}
.p-color {
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
  color: #fff;
}
.arrows {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.color-dialog >>> .p-dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.dialog-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.color-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 10px 0;
}

.preview-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.color-preview {
  width: 80px;
  height: 80px;
  border-radius: 10px;
  border: 1px solid #ccc;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  margin-bottom: 10px;
  transition: background-color 0.3s ease;
}

.color-code {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
